module.exports = __webpack_public_path__ + "img/27.cad3de8d.jpg";